const Colors = {
	mainColor: "#2da081",
	blue: "#529be5",
	malt: "#fc5656",
	linkedin: "#006699",
};

export default Colors;
